/* Fills all hidden inputs created by 'dpc-lineitem-hidden-inputs.liquid' and keeps them in sync */
(function () {
  function sync(props) {
    if (!props || typeof props !== 'object') return;
    Object.entries(props).forEach(([key, val]) => {
      document.querySelectorAll(`input[data-dpc-prop="${key}"]`)
        .forEach(el => { el.value = (val ?? '').toString(); });
    });
  }
  // Expose
  window.dpcSyncProps = sync;

  // Auto-fill newly added forms/snippets
  const mo = new MutationObserver(() => { if (window.__DPC_PROPS) sync(window.__DPC_PROPS); });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // If props were set before this script loaded, apply now
  if (window.__DPC_PROPS) sync(window.__DPC_PROPS);
})();